import { useTranslation } from 'react-i18next';

import { PlusIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useModal } from '@/components/modals/new/use-modal';
import { AddContactModal } from './modals/add-contact-modal';

export const AddContactButton = ({ tenantId }: { tenantId: string }) => {
  const { t } = useTranslation();
  const modal = useModal();

  return (
    <>
      <Button aria-label={t('add-contact')} variant="outline" onClick={modal.open}>
        <PlusIcon aria-hidden />
      </Button>
      <AddContactModal modal={modal} tenantId={tenantId} />
    </>
  );
};
